import { createApp } from 'vue';
import { HpsfirManageBaseUI, HpsfirManageBaseUIApp, HpsfirComponentsMap, HpsfirManageBaseOption } from 'hpsfir-managebase-ui';
import 'hpsfir-managebase-ui/lib/lib.css';
import './style/global.scss';
import { initApi } from './hooks/useApi';
import AdminLayout from './layout/admin/AdminLayout.vue';
import Login from './layout/login/index.vue';

const allComponents: HpsfirComponentsMap = {};
const viewRequireCnt = require.context('./views', true, /index\.vue$/u);
viewRequireCnt.keys().forEach((key) => {
  const keySplits = key.split('/');
  const dirname = keySplits[keySplits.length - 2];
  console.log(dirname);
  allComponents[dirname!] = () => viewRequireCnt(key).default || viewRequireCnt(key);
});

initApi('/api');

createApp(HpsfirManageBaseUIApp)
  .use(HpsfirManageBaseUI, {
    siteName: 'Dz Poker',
    baseApiPath: '/api',
    viewMap: allComponents,
    adminLayoutCnt: AdminLayout,
    loginCnt: Login,
    description: '管理后台',
    logo: '/logo.png',
  } as HpsfirManageBaseOption)
  .mount('#app');
